import React from 'react';
import { Star } from 'lucide-react';

const testimonials = [
  { name: 'Alexandra Mercer', role: 'CEO, Meridian Commerce', service: 'Trademark', content: 'The firm handled our entire trademark portfolio with exceptional precision. Every step was documented and communicated with the professionalism we expect from top-tier counsel.' },
  { name: 'Jonathan Reeves', role: 'Founder, Reeves Technology', service: 'Copyright', content: 'Our software IP required comprehensive protection across multiple jurisdictions. Their team delivered a thorough strategy that exceeded our expectations.' },
  { name: 'Diana Whitfield', role: 'Creative Director, Whitfield Atelier', service: 'Trademark', content: 'As a luxury fashion house, our brand identity is our most valuable asset. The service quality was indistinguishable from firms charging ten times as much.' },
  { name: 'Marcus Blackwell', role: 'Managing Partner, Blackwell Hospitality', service: 'Company Formation', content: 'They structured our LLC, registered our trademarks, and established our brand protection framework — all with remarkable efficiency.' },
  { name: 'Priya Sharma', role: 'Chief Innovation Officer, NovaTech', service: 'Patent', content: 'Our patent application for proprietary technology was handled with technical sophistication and legal rigor. The attorneys understood both the engineering and the law.' }
];

const LPTestimonialsSlider = () => {
  const all = [...testimonials, ...testimonials];
  return (
    <section className="py-24 bg-[#EAE7DF]" data-testid="lp-testimonials-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <p className="eyebrow mb-4">Client Testimonials</p>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-[#111C16] tracking-tighter">What our clients say</h2>
        </div>
        <div className="overflow-hidden">
          <div className="flex animate-marquee-lp" style={{ width: 'max-content' }}>
            {all.map((t, i) => (
              <div key={i} className="w-[340px] md:w-[400px] flex-shrink-0 px-3">
                <div className="bg-white rounded-3xl p-8 border border-[#D5D1C8] h-full flex flex-col">
                  <div className="flex space-x-1 mb-4">
                    {[...Array(5)].map((_, j) => <Star key={j} className="h-3.5 w-3.5 fill-[#C85A40] text-[#C85A40]" />)}
                  </div>
                  <p className="font-body text-sm text-[#4A5D53] mb-6 leading-relaxed flex-grow">"{t.content}"</p>
                  <div className="pt-4 border-t border-[#D5D1C8]">
                    <h4 className="font-display text-sm font-medium text-[#111C16]">{t.name}</h4>
                    <p className="font-body text-xs text-[#4A5D53]">{t.role}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LPTestimonialsSlider;
